/* eslint-disable react/prop-types */
import DatePicker from 'components/dashboards/manage-projects/DatePicker';
import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import DateRangeSelector from 'screens/common/components/DateRangeSelector';
import Select from 'react-select';

export const TableHeader = ({
  table,
  setShowColumnSelector,
  showColumnSelector,
  handleGlobalSearch,
  globalfilters,
  dateRangePicker,
  globalSearch = true,
  dateFilter,
  showFilters = true,
  handleDateChange,
  dropdownFilter,
  dropdownData,
  dropdownOptions,
  selectedValues,
  setSelectedValues
}) => {
  const [selectedRange, setSelectedRange] = useState({
    value: 'this_month',
    label: 'This Month'
  });

  const parseDateToJSDate = dateStr => {
    if (!dateStr) return null;
    const [year, month, day] = dateStr.split('-');
    return new Date(year, parseInt(month, 10) - 1, day);
  };

  const formatDateForDisplay = date => {
    if (!date) return '';
    const jsDate = new Date(date);
    const day = String(jsDate.getDate()).padStart(2, '0');
    const month = String(jsDate.getMonth() + 1).padStart(2, '0');
    const year = jsDate.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleDateRangeChange = (date, field) => {
    if (date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const formattedForQuery = `${year}-${month}-${day}`;
      handleDateChange(formattedForQuery, field);
    } else {
      handleDateChange('', field);
    }
  };

  const customStyles = {
    control: provided => ({
      ...provided,
      minHeight: '80px',
      backgroundColor: 'blue'
    }),
    valueContainer: provided => ({
      ...provided,
      whiteSpace: 'nowrap',
      overflowY: 'auto',
      textOverflow: 'ellipsis',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      maxWidth: '200px',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignContent: 'flex-start',
      maxHeight: '90px'
    }),

    multiValue: provided => ({
      ...provided,
      backgroundColor: 'yellow',
      height: 'fit-content'
    }),
    multiValueLabel: provided => ({
      ...provided
    })
  };

  return (
    <div className="justify-content-end mb-1 flex-1 px-3">
      <div
        className={`d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3 ${
          showFilters ? '' : 'd-none d-md-flex'
        }`}
      >
        <div className="d-flex flex-column flex-md-row gap-3">
          {globalSearch && (
            <input
              type="text"
              placeholder="Search..."
              className="form-control w-100"
              onChange={e => handleGlobalSearch(e.target.value)}
            />
          )}
          {/* <Button
            variant="primary"
            size="sm"
            onClick={() => setShowColumnSelector(true)}
          >
            Column
          </Button> */}
        </div>
        <div className="d-flex flex-column flex-md-row gap-3 w-100 w-md-auto">
          {dateRangePicker && (
            <DateRangeSelector
              selectedRange={selectedRange}
              setSelectedRange={setSelectedRange}
              handleDateChange={handleDateRangeChange}
              styleWidth={true}
            />
          )}
          <div className="datepicker-wrapper flex-grow-1 flex-md-shrink-0">
            {dateFilter && (
              <DatePicker
                selected={parseDateToJSDate(globalfilters.dateRange.start_date)}
                onChange={date => handleDateRangeChange(date, 'start_date')}
                placeholderText="Start Date"
                className="form-control"
                dateFormat="dd-MM-yyyy"
                maxDate={
                  parseDateToJSDate(globalfilters.dateRange.end_date) ||
                  new Date()
                }
                value={formatDateForDisplay(globalfilters.dateRange.start_date)}
              />
            )}
          </div>

          <div className="datepicker-wrapper flex-grow-1 flex-md-shrink-0">
            {dateFilter && (
              <DatePicker
                selected={parseDateToJSDate(globalfilters.dateRange.end_date)}
                onChange={date => handleDateRangeChange(date, 'end_date')}
                placeholderText="End Date"
                className="form-control"
                dateFormat="dd-MM-yyyy"
                minDate={parseDateToJSDate(globalfilters.dateRange.start_date)}
                maxDate={new Date()}
                value={formatDateForDisplay(globalfilters.dateRange.end_date)}
              />
            )}
          </div>

          {dateFilter &&
            (globalfilters.dateRange.start_date ||
              globalfilters.dateRange.end_date) && (
              <button
                type="button"
                className="btn btn-outline-secondary align-self-md-start"
                onClick={() => {
                  handleDateChange('', 'start_date');
                  handleDateChange('', 'end_date');
                }}
              >
                Clear
              </button>
            )}
          <div className="d-flex flex-wrap gap-3">
            {dropdownFilter &&
              dropdownData.map(drop => (
                <div
                  key={drop.key}
                  className="dropdown-filter flex-grow-1 flex-md-shrink-0"
                >
                  <Select
                    options={dropdownOptions[drop.key] || []}
                    isClearable={true}
                    placeholder={drop.label}
                    classNamePrefix="react-select"
                    value={
                      drop.isMulti
                        ? (selectedValues[drop.key] || [])
                            .map(v =>
                              dropdownOptions[drop.key]?.find(
                                opt => opt.value === v
                              )
                            )
                            .filter(Boolean)
                        : dropdownOptions[drop.key]?.find(
                            opt => opt.value === selectedValues[drop.key]
                          ) || null
                    }
                    onChange={selected => {
                      const selectedValues = drop.isMulti
                        ? selected
                          ? selected.map(item => item.value)
                          : []
                        : selected
                        ? selected.value
                        : null;

                      setSelectedValues(prev => ({
                        ...prev,
                        [drop.key]: selectedValues
                      }));
                    }}
                    isMulti={drop.isMulti}
                    closeMenuOnSelect={!drop.isMulti}
                    styles={{
                      ...customStyles,
                      control: base => ({
                        ...base,
                        minWidth: '200px',
                        maxWidth: '400px',
                        width: '100%'
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        color: state.isDisabled ? '#d3d3d3' : '#000',
                        fontWeight: state.isDisabled ? 'lighter' : 'bold',
                        cursor: state.isDisabled ? 'not-allowed' : 'pointer'
                      })
                    }}
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};
